<template>
  <div class="is-flex py-2">
    <up-label class="" :label="label" :labelIcon="labelIcon"></up-label>
    <select
      ref="colorinput"
      @focus="randomColor()"
      @blur="defaultColor()"
      v-model="computedValue"
      :style="`width: ${sizeOfInputField}rem`"
    >
      <option :value="null" disabled selected hidden>{{ placeholder }}</option>
      <slot></slot>
    </select>
  </div>
</template>

<script>
import UpLabel from "../Label";
import { addRandomBorderColor } from "./RandomColor.js";
export default {
  name: "up-select",
  components: {
    UpLabel,
  },
  props: {
    label: {
      type: String,
    },
    labelIcon: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Select",
    },
    size: {
      type: String,
      default: "sm",
    },
    value : {
      type : [String, Number, Boolean, Object, Array, Function, Date],
    }
  },
  data() {
    return {
      local_up_select: this.value,
      randColor: addRandomBorderColor,
    };
  },
  methods: {
    randomColor() {
      let color = this.randColor();

      let input_element = this.$refs.colorinput;
      input_element.style.border = `2px solid ${color}`;
    },
    defaultColor() {
      let input_element = this.$refs.colorinput;
      input_element.style.border = "2px solid black";
    },
  },
  computed: {
    computedValue : {
      get(){
        return this.local_up_select
      },
      set(value){
        this.local_up_select = value
        this.$emit('input', value)
      },
    },
    sizeOfInputField() {
      let sizes = { xs: 4, sm: 6, md: 8, lg: 10, xl: 12 };
      if (sizes[this.size]) {
        return sizes[this.size];
      } else {
        return 5;
      }
    },
  },
  watch: {
    value: {
      handler: function(new_val) {
        this.local_up_select = new_val;
      },
    },
  },
};
</script>

<style scoped>
select {
  padding: 2px 2px;
  width: 7rem;
  height: 1.7rem;
  background: white;
  border: 2px solid black;
}
</style>
